import { useEffect } from 'react'

/**
 * Inject or update a JSON-LD script tag; removes on unmount.
 * @param {string} dataAttr - e.g. data-emdr-schema
 * @param {object|null|undefined} graph - schema.org object
 * @param {boolean} enabled
 */
export function useJsonLd (dataAttr, graph, enabled = true) {
  const serialized = graph ? JSON.stringify(graph) : null

  useEffect(() => {
    if (!enabled || !serialized) return undefined

    const selector = `script[type="application/ld+json"][${dataAttr}]`
    let el = document.querySelector(selector)
    if (!el) {
      el = document.createElement('script')
      el.setAttribute('type', 'application/ld+json')
      el.setAttribute(dataAttr, 'true')
      document.head.appendChild(el)
    }
    el.textContent = serialized

    return () => {
      document.querySelector(selector)?.remove()
    }
  }, [dataAttr, enabled, serialized])
}
